import React from 'react'
import './main.css'

function Main() {
    return (
      
< >
<div className='d-flex justify-content-center align-items-start'>
<section id='home' className="primary py-5 d-flex flex-lg-row flex-column">
<div data-aos="zoom-in"  data-aos-duration="3000" className='px-2 px-md-5 firstl d-flex flex-column'> 
<div className='twenty-percent my-2 py-1' > 
  <p><span className="text-white"> 20% </span><span className="text-secondary">DISCOUNT </span><span className="text-white">1 MONTH</span><span className="text-secondary"> ACCOUNT</span></p>
</div>

<div className='d-flex gen'>
  <div className='gen-child'><h1 className='text-white'>The Next</h1> <h1 className='text-gradient'>Generation</h1></div>
<div className='get-started'></div>
</div>
<div>
  <h1 className='text-white'>Payment</h1>
  <h1 className='text-white'>Method</h1>
  <p className='text-white p'>Our team of experts uses a methodology to identify the credit cards most likely to fit your needs we examine annual percentage rates, annual fees</p>
</div>
</div>
<div data-aos="zoom-in"  data-aos-duration="3000" className='firstr d-flex justify-content-center align-items-center'>

  <img src='assets/Group481777.png' className='robothand' alt='Robothand'/>
</div>
</section>
</div>
{/* about us */}
<div id='about'className='d-flex px-5 align-items-start justify-content-center '>
<div style={{width:'100%'}}>
<section className='d-flex align-items-center justify-content-center flex-wrap mb-8'>
  <div data-aos="zoom-in-up" className='align-items-center m-3 d-flex justify-content-start '><h3 className='text-white'>3800+</h3><h4 className='text-gradient'> ACTIVE USERS</h4></div>
  <div data-aos="zoom-in-up" className='align-items-center m-3 d-flex justify-content-start '><h3 className='text-white'>230+</h3><h4 className='text-gradient'> TRUSTED BY COMPANY</h4></div>
  <div data-aos="zoom-in-up" className='align-items-center m-3 d-flex justify-content-start '><h3 className='text-white'>$230M+</h3><h4 className='text-gradient'> TRANSACTION</h4></div>
</section>

<section className="primary py-5 d-flex flex-lg-row flex-column">
<div data-aos="fade-right" className=' firstl d-flex flex-column'> 
  <h2 className='text-white pb-4 pe-1' style={{fontSize:'50px', fontWeight:"650"}}>You do the Business
we'll handle the money</h2>
  <p className='text-white fs-5 p pb-2 pb-sm-4'>With the right credit card,you can impove your financial life by building credit,earning rewards and saving money with hundreds of credit cards on the market</p>
<button className="started-button mb-4 py-3">Get Started</button>
  </div>
<div data-aos="fade-right" className='firstr d-flex flex-column'>
<div className='d-flex ps-1 py-2 pe-2 align-items-center rewards firstr'>
  <div><img src='assets/Group481727.png' alt='' className='ps-0 pb-1 pe-2'/></div>
  <div className='d-flex text-white flex-column'>
    <h2>Rewards</h2>
    <p className='pa'>The best credit cards offer some tantalizing combinations of promotions and prizes</p>
  </div>
</div>
<div className='d-flex ps-1 py-2 pe-2 align-items-center rewards text-white firstr'>
  <div><img src='assets/Group481744.png' alt='' className='ps-0 pb-1 pe-2'/></div>
  <div className='d-flex flex-column'> 
    <h2>100% Secured</h2>
    <p className=' pa'>We take proactive steps make sure your information and transactions are secure.</p>
  </div>
</div>
<div className='d-flex ps-1 py-2 pe-2 text-white rewards align-items-center firstr'>
  <div><img src='assets/Group481745.png' alt='' className='ps-0 pb-1 pe-2'/></div>
  <div className='d-flex flex-column'>
    <h2>Balance Transfer</h2>
    <p className='pa'>A balance transfer credit card can save you a lot of money in interest charges.</p>
  </div>
</div>
</div>
</section>

</div>
</div>

{/* features */}
<div id='features' className='d-flex px-5 justify-content-center align-items-center'>
<div style={{width:'100%'}}>
<section className="primary py-5 d-flex flex-lg-row flex-column">
<div data-aos="fade-left" className='firstl d-flex justify-content-center align-items-center'>
  <img src='assets/Group481776.png' className='robothand' alt='Robothand'/>
</div>

<div data-aos="fade-left" className=' firstr d-flex flex-column ps-lg-5'> 
  <h2 className='text-white pt-3 pb-2 pb-sm-4' style={{fontSize:'50px', fontWeight:"650"}}>Easily control</h2>
  <h2 className='text-white pb-2 pb-sm-4' style={{fontSize:'50px', fontWeight:"650"}}>your billing &</h2>
  <h2 className='text-white pb-2 pb-sm-4' style={{fontSize:'50px', fontWeight:"650"}}>invoicing</h2>
  <p className='text-white fs-5 p pb-4'>Elit enim sed massa etiam MAuris euadipscing ultrices ametodio aenanen anenwue. Fuse ipsum orci rhoncus aliporttiot integer platea placerat</p>
<div className='d-flex flex-row mt-2' >
<img src='assets/Group481724.png' alt='' className='me-3'/>
<img src='assets/Group481725.png' alt='' />
</div>
  </div>
</section>

<section className="primary py-5 d-flex flex-lg-row flex-column">
<div data-aos="fade-right" className=' firstl d-flex flex-column mb-3 mb-sm-0'> 
  <h2 className='text-white pb-2 pb-sm-4' style={{fontSize:'50px', fontWeight:"650"}}>Find a better</h2>
  <h2 className='text-white pb-2 pb-sm-4' style={{fontSize:'50px', fontWeight:"650"}}>card deal</h2>
  <h2 className='text-white pb-2 pb-sm-4' style={{fontSize:'50px', fontWeight:"650"}}>in a few easy steps</h2>
  <p className='text-white fs-5 p pb-sm-4'>With the right credit card,you can impove your financial life by building credit,earning rewards and saving money with hundreds of credit cards on the market</p>
<button className="started-button mb-2 mb-sm-4 py-3">Get Started</button>
  </div>
  <div data-aos="fade-right" className='firstl d-flex justify-content-center align-items-center'>
  <img src='assets/Group481775.png' className='robothand' alt='Robothand'/>
</div>

</section>

</div>
</div>

{/* clients */}
<div id='client' className='d-flex px-2 justify-content-center align-items-center'>
<div style={{width:'100%'}}>
<section className="primary py-5 ps-3 d-flex flex-lg-row flex-column">
<div data-aos="fade-up" className=' firstl d-flex flex-column'> 
  <h2 className='text-white pb-1 pe-1' style={{fontSize:'50px', fontWeight:"650"}}>What People are
</h2>
<h2 className='text-white pb-4 pe-1' style={{fontSize:'50px', fontWeight:"650"}}>
Saying about us</h2>

  </div>
<div data-aos="fade-up" className='firstr d-flex p-8 align-items-center'>
    <p className='text-white fs-5 p pb-4'>Everything you need to accept card payments and grow your business anywhere on the planet.</p>
  </div>
</section>

<section className='d-flex justify-content-center justify-content-lg-start flex-wrap mb-5'>
  <div data-aos="fade-up" className=' clients  d-flex justify-content-between flex-column gen-child'>
  <div className='d-flex flex-column'>
    <img src='assets/quotes.png' className='quotes' alt='quotes'/>
    <p className='text-white pa my-4'>Money is only a tool. It will take you wherever you wish, but it will not replace you as the driver.</p>
</div>
  <div className='d-flex align-items-center'>
    <img src='assets/jensen.png' className='client-img' alt='clients'/>
    <h5 className='text-white ms-2' >Herman Jensen</h5>
      </div>
    </div>
    <div data-aos="fade-up" className='clients  d-flex justify-content-between flex-column gen-child'>
    <div className='d-flex flex-column'>
      <img src='assets/quotes.png' className='quotes' alt='quotes'/>
    <p className='text-white pa my-4'>Money makes your life easier. If you're lucky to have it, you're lucky.</p>
    </div>
  <div className='d-flex align-items-center'>
    <img src='assets/jensen.png' className='client-img' alt='clients'/>
    <h5 className='text-white ms-2' >Steve Mark</h5>
      </div>
    </div>
    <div data-aos="fade-up" className='clients  d-flex justify-content-between flex-column gen-child'>
    <div className='d-flex flex-column'>
    <img src='assets/quotes.png' className='quotes' alt='quotes'/>
    <p className='text-white pa my-4'>It is usually people in the money business, finance, and international trade that are really rich.</p>
    </div>
  <div className='d-flex align-items-center'>
    <img src='assets/jensen.png' className='client-img' alt='clients'/>
    <h5 className='text-white ms-2'>Ken Gallagher</h5>
      </div>
    </div>
    
</section>
<section className='d-flex justify-content-center align-items-center flex-wrap mb-5'>
<div className="d-flex justify-content-center gen-child align-items-center me-1">
  <img src='assets/airbnb.png'alt='' className='airbnb'/>
  </div>
  <div className="d-flex justify-content-center  gen-child align-items-center me-1">
  <img src='assets/binance.png'alt='' className='airbnb'/>
  </div>
  <div className="d-flex justify-content-center gen-child pb-2 align-items-center me-1">
  <img src='assets/coinbase.png'alt='' className='airbnb'/>
  </div>
  <div className="d-flex justify-content-center  gen-child align-items-center me-1">
  <img src='assets/dropbox.png'alt='' className='airbnb'/>
  </div>
  </section>

<section className='d-flex justify-content-center align-items-center mb-5'>
<div data-aos="fade-right" className=' firstl start d-flex justify-content-between align-items-center flex-md-row flex-column p-3'> 
  <div className='d-flex firstl flex-column talign px-md-3 justify-content-between'>
  <h2 className='text-white pb-4 pe-1' style={{fontSize:'50px', fontWeight:"650"}}>Lets try our service now</h2>
  <p className='text-white fs-5 p pb-4'>Everything you need to accept card payments and grow your business anywhere on the planet.</p>
  </div>
<button className="started-button m-4 py-3">Get Started</button>
  </div>

</section>

</div>
</div>
</>
      )
}

export default Main